export default "__VITE_ASSET__DZ3w4FUP__"